import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faSearch,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faAngleDown,
  faAngleRight,
  faBars,
  faSearch,
  faHeart,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
